export default {
      id: "i-check-new-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/sprite.svg#i-check-new",
      toString: function () {
        return this.url;
      }
    }